import React, { useEffect, useState } from 'react';
import { useMessageNotifications } from '../hooks/useMessageNotifications';

const PRIMARY_BROWN = '#C97B53';
const NEUTRAL_WHITE = '#FFF';
const NEUTRAL_TEXT = '#222';
const ACCENT_GRAY = '#757575';

const bodyFont = { fontFamily: 'Montserrat, sans-serif', fontWeight: 500 };

export function MessageNotification() {
  const { getTotalUnreadCount } = useMessageNotifications();
  const [showNotification, setShowNotification] = useState(false);
  const [previousCount, setPreviousCount] = useState(0);

  useEffect(() => {
    const currentCount = getTotalUnreadCount();
    
    // Show notification when unread count increases
    if (currentCount > previousCount && previousCount > 0) {
      setShowNotification(true);
      
      // Auto-hide after 5 seconds
      const timer = setTimeout(() => {
        setShowNotification(false);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
    
    setPreviousCount(currentCount);
  }, [getTotalUnreadCount, previousCount]);

  if (!showNotification) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 20,
      right: 20,
      background: NEUTRAL_WHITE,
      borderRadius: 12,
      padding: '16px 20px',
      boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
      zIndex: 1001,
      maxWidth: 300,
      border: `2px solid ${PRIMARY_BROWN}`,
      animation: 'slideIn 0.3s ease-out'
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12
      }}>
        <div style={{
          width: 8,
          height: 8,
          background: PRIMARY_BROWN,
          borderRadius: '50%',
          animation: 'pulse 2s infinite'
        }} />
        <div>
          <div style={{
            fontSize: 14,
            fontWeight: 600,
            color: NEUTRAL_TEXT,
            marginBottom: 2,
            ...bodyFont
          }}>
            New Message
          </div>
          <div style={{
            fontSize: 12,
            color: ACCENT_GRAY,
            ...bodyFont
          }}>
            You have {getTotalUnreadCount()} unread message{getTotalUnreadCount() !== 1 ? 's' : ''}
          </div>
        </div>
        <button
          onClick={() => setShowNotification(false)}
          style={{
            background: 'transparent',
            border: 'none',
            fontSize: 18,
            cursor: 'pointer',
            color: ACCENT_GRAY,
            padding: 0,
            marginLeft: 'auto'
          }}
        >
          ×
        </button>
      </div>
      
      <style jsx>{`
        @keyframes slideIn {
          from {
            transform: translateX(100%);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
}
